// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const parseIntFromInt = (val: string | number, radix: number): number => parseInt(val, radix);
